/**
 * Which locations render without the shell header.
 *
 * `AppShell` puts the wordmark, the bell, Account and Sign out above every
 * signed-in screen. One screen goes without them: a pool takes over the top
 * of the viewport with its own back arrow, title and share control
 * (ISSUE-952 R1). The four section tabs are not part of this opt-out any
 * more: `AppShell` keeps them on the pool screen at phone width, as the
 * bottom bar (ISSUE-965). This module is the whole seam, kept pure so the
 * answer is a plain boolean a test can pin without mounting a router.
 *
 * A location, not a route id: the pool screen is `/pools` with a `poolId`
 * search param, because `apps/app/src/routes/__root.tsx` holds the only
 * `<Outlet />` in the routes tree and a child route would never paint.
 *
 * The raw location search is read through `coerceOptionalString`, the same
 * coercer `validatePoolsSearch` uses. TanStack's parser runs `JSON.parse` on
 * every raw value, so an all-digit pool id arrives here as a number. A
 * `typeof value === "string"` guard would then keep the chrome on a screen
 * the route itself is painting as a pool.
 */
import { coerceOptionalString } from "../routeState/searchParams";

export function isChromelessLocation({
  pathname,
  search,
}: {
  pathname: string;
  search: Record<string, unknown>;
}): boolean {
  if (pathname !== "/pools") return false;
  return coerceOptionalString(search.poolId) !== undefined;
}
